module.exports = __webpack_public_path__ + "img/headimg.df14cce3.png";